import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Ramesh Patel",
    place: "Gujarat",
    msg: "Goodweel Crop Care ke products se fasal healthy rahi aur yield clearly improve hui.",
    rating: 5
  },
  {
    name: "Suresh Yadav",
    place: "Madhya Pradesh",
    msg: "Time par product milta hai aur quality har baar consistent hoti hai.",
    rating: 5
  },
  {
    name: "Mahesh Singh",
    place: "Uttar Pradesh",
    msg: "Eco-friendly products hone ki wajah se soil health bhi safe rahi.",
    rating: 5
  },
  {
    name: "Anil Verma",
    place: "Rajasthan",
    msg: "Cost effective solutions hain aur results field me clearly dikhte hain.",
    rating: 5
  },
  {
    name: "Vikram Chauhan",
    place: "Haryana",
    msg: "Company ka support aur guidance dono strong hai.",
    rating: 5
  },
  {
    name: "Dinesh Pawar",
    place: "Maharashtra",
    msg: "Crop protection ke liye ek trusted brand ban chuka hai.",
    rating: 5
  }
];

const Testimonials = () => {
  return (
    <section className="testimonial-section">
      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <h6 className="section-subtitle">FARMER TESTIMONIALS</h6>
          <h2 className="section-title">
            Trusted by <span>Farmers Across India</span>
          </h2>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={25}
          slidesPerView={3}
          grabCursor={true}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 }
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">

                {/* STARS */}
                <div className="stars">
                  {"★".repeat(item.rating)}
                  {"☆".repeat(5 - item.rating)}
                </div>

                <p className="testimonial-msg">“{item.msg}”</p>

                <h5>{item.name}</h5>
                <span>{item.place}</span>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Testimonials;
